import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { PageHeaderPrimitives } from '@uhg-abyss/web/ui/PageHeader';
import { PageBody } from '@uhg-abyss/web/ui/PageBody';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Box } from '@uhg-abyss/web/ui/Box';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import { handleLogout } from '@src/tools/handleLogout';

const MainContainer = styled('div', {
  minHeight: 'calc(100vh)',
  background: '$gray2',
  zIndex: 1200,
});

const FlexContainer = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
});

const StyledPageBody = styled(PageBody, {
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: 1320,
  '@media screen and (max-width: 1380px)': {
    paddingLeft: 40,
    paddingRight: 40,
  },
});

const MarginTop = styled('div', {
  marginTop: 25,
});

const DialogContainer = styled('div', {
  textAlign: 'center',
  marginTop: '50px',
  maxWidth: '80%',
  margin: '0 auto',
});

export const ErrorPage = () => {
  const errorDetails = {
    title: 'Service Unavailable',
    desc: 'We are working on restoring this service as quickly as possible.',
    subtitle: 'Please try again later.',
  };
  return (
    <React.Fragment>
      <MainContainer data-testid='initialize-app-error-page'>
        <PageHeaderPrimitives.Container>
          <FlexContainer>
            <PageHeaderPrimitives.Brandmark />
            <div>
              <Link
                onClick={handleLogout}
              >
                Logout
              </Link>
            </div>
          </FlexContainer>
        </PageHeaderPrimitives.Container>
        <StyledPageBody>
          <MarginTop />
          <DialogContainer>
            <Box color='white'>
              <Layout.Stack alignLayout='center' space={16}>
                <IconBrand size='72' icon='alert' />
                <Heading data-testid='initialize-app-error-page-title'>
                  {errorDetails.title}
                </Heading>
                <Layout.Stack alignLayout='center' space={0}>
                  <Text data-testid='initialize-app-error-page-desc'>
                    {errorDetails.desc}
                  </Text>
                  <Text data-testid='initialize-app-error-page-subtitle'>
                    {errorDetails.subtitle}
                  </Text>
                </Layout.Stack>
              </Layout.Stack>
            </Box>
          </DialogContainer>
        </StyledPageBody>
      </MainContainer>
    </React.Fragment>
  );
};
